<template>
	<div class="container p-0">
		<div class="mb-5 carousel-top">
			<header class="mb-4">
				<h2>Travel like bloggers</h2>
			</header>
			<carousel autoplayDirection="forward" :autoplayHoverPause="true" :paginationEnabled="false" :autoplayTimeout="3000" :autoplay="true" :navigationEnabled="true" navigationNextLabel="<i class='fas fa-chevron-right'></i>" navigationPrevLabel="<i class='fas fa-chevron-left'></i>" :loop="true" :perPageCustom="[[1, 1], [577, 2], [768, 2], [992, 3], [1044, 3], [1200, 4]]">
				<slide v-for="(slide, index) in slides" :key="index">
					<div class="card-group influencer-container">
						<article class="influencer-featured card">
							<div class="influencer-image">
								<div class="bell-icon"><i class="fas fa-bell"></i></div>
								<img :src="slide.image" class="card-img-top">
							</div>
							<div class="d-block p-2">
								<ul class="text-caption-small poi-item-tags">
								<li class="poi-item-tag"><span>tag1</span><span>tag2</span><span>tag3</span><span>tag4</span></li>
								</ul>
								<div class="row m-0 mt-2">
									<div class="influencer-description title col-11 pl-0">
										{{slide.content}}
									</div>
									<div class="favorite-icon col-1 p-0 d-flex justify-content-end" @click="myFavorite(index)">
										<i v-if="isActive[index]" class="fas fa-heart"></i>
										<i v-else class="far fa-heart"></i>
									</div>
								</div>
								
								<p class="text-caption-small influencer-tags">
									<span class="text-grey"><span class="icon pr-2"><i class="fas fa-map-marker-alt"></i></span>{{slide.day}}</span>
								</p>
								<div class="row m-0">
									<div class="float-left mt-auto">
										<img class="" src="@/assets/images/jiso-logo.png" width="52px">
									</div>
									<div class="float-right ml-auto">
										<div class="influencer-description influencer-price">
											<small>Lorem ipsum</small>
											<h5 class="m-0">{{slide.price}}</h5>
										</div>
									</div>
								</div>
							</div>
						</article>
					</div>
				</slide>
			</carousel>
		</div>

		<div class="mb-5 carousel-bottom">
			<header class="mb-4">
				<h2>Travel like bloggers</h2>
			</header>
			<carousel autoplayDirection="backward" :autoplayHoverPause="true" :paginationEnabled="false" :autoplayTimeout="4000" :autoplay="true" :navigationEnabled="true" navigationNextLabel="<i class='fas fa-chevron-right'></i>" navigationPrevLabel="<i class='fas fa-chevron-left'></i>" :loop="true" :perPageCustom="[[1, 1], [577, 2], [768, 2], [992, 3], [1044, 3], [1200, 4]]">
				<slide v-for="(slide, index) in slides" :key="index">
					<div class="card-group influencer-container">
						<article class="influencer-featured card">
							<div class="influencer-image">
								<div class="bell-icon"><i class="fas fa-bell"></i></div>
								<img :src="slide.image" class="card-img-top">
							</div>
							<div class="d-block p-2">
								<ul class="text-caption-small poi-item-tags">
								<li class="poi-item-tag"><span>tag1</span><span>tag2</span><span>tag3</span><span>tag4</span></li>
								</ul>
								<div class="row m-0 mt-2">
									<div class="influencer-description title col-11 pl-0">
										{{slide.content}}
									</div>
									<div class="favorite-icon col-1 p-0 d-flex justify-content-end" @click="myFavorite(index)">
										<i v-if="isActive[index]" class="fas fa-heart"></i>
										<i v-else class="far fa-heart"></i>
									</div>
								</div>
								
								<p class="text-caption-small influencer-tags">
									<span class="text-grey"><span class="icon pr-2"><i class="fas fa-map-marker-alt"></i></span>{{slide.day}}</span>
								</p>
								<div class="row m-0">
									<div class="float-left mt-auto">
										<img class="" src="@/assets/images/jiso-logo.png" width="52px">
									</div>
									<div class="float-right ml-auto">
										<div class="influencer-description influencer-price">
											<small>Lorem ipsum</small>
											<h5 class="m-0">{{slide.price}}</h5>
										</div>
									</div>
								</div>
							</div>
						</article>
					</div>
				</slide>
			</carousel>
		</div>

		<div class="mb-5 carousel-bottom">
			<header class="mb-4">
				<h2>Travel like bloggers</h2>
			</header>
			<carousel autoplayDirection="forward" :autoplayHoverPause="true" :paginationEnabled="false" :autoplayTimeout="5000" :autoplay="true" :navigationEnabled="true" navigationNextLabel="<i class='fas fa-chevron-right'></i>" navigationPrevLabel="<i class='fas fa-chevron-left'></i>" :loop="true" :perPageCustom="[[1, 1], [577, 2], [768, 2], [992, 3], [1044, 3], [1200, 4]]">
				<slide v-for="(slide, index) in slides" :key="index">
					<div class="card-group influencer-container">
						<article class="influencer-featured card">
							<div class="influencer-image">
								<div class="bell-icon"><i class="fas fa-bell"></i></div>
								<img :src="slide.image" class="card-img-top">
							</div>
							<div class="d-block p-2">
								<ul class="text-caption-small poi-item-tags">
								<li class="poi-item-tag"><span>tag1</span><span>tag2</span><span>tag3</span><span>tag4</span></li>
								</ul>
								<div class="row m-0 mt-2">
									<div class="influencer-description title col-11 pl-0">
										{{slide.content}}
									</div>
									<div class="favorite-icon col-1 p-0 d-flex justify-content-end" @click="myFavorite(index)">
										<i v-if="isActive[index]" class="fas fa-heart"></i>
										<i v-else class="far fa-heart"></i>
									</div>
								</div>
								
								<p class="text-caption-small influencer-tags">
									<span class="text-grey"><span class="icon pr-2"><i class="fas fa-map-marker-alt"></i></span>{{slide.day}}</span>
								</p>
								<div class="row m-0">
									<div class="float-left mt-auto">
										<img class="" src="@/assets/images/jiso-logo.png" width="52px">
									</div>
									<div class="float-right ml-auto">
										<div class="influencer-description influencer-price">
											<small>Lorem ipsum</small>
											<h5 class="m-0">{{slide.price}}</h5>
										</div>
									</div>
								</div>
							</div>
						</article>
					</div>
				</slide>
			</carousel>
		</div>
	</div>
</template>

<script>
export default {
  name: 'HomeInfluencerPresetTabs',
  data() {
  return {
  isActive: [],
  slides: [{
  id: 1,
  title: 'Experience designed by',
  subtitle: 'JISO',
  content: 'เมืองที่ยังคงความสวยงามด้วยสถาปัตยกรรมโบราณดั้งเดิม',
  tag: 'Zoo, Travel, Flower',
  day: 'Location',
  price: 'THB 2,500',
  image: require('@/assets/images/fox.jpg'),
  },
  {
  id: 2,
  title: 'Experience designed by',
  subtitle: 'JISO',
  content: 'เมืองที่ยังคงความสวยงามด้วยสถาปัตยกรรมโบราณดั้งเดิม',
  tag: 'Zoo, Travel, Flower',
  day: 'Location',
  price: 'THB 2,500',
  image: require('@/assets/images/fox.jpg'),
  },
  {
  id: 3,
  title: 'Experience designed by',
  subtitle: 'JISO',
  content: 'เมืองที่ยังคงความสวยงามด้วยสถาปัตยกรรมโบราณดั้งเดิม',
  tag: 'Zoo, Travel, Flower',
  day: 'Location',
  price: 'THB 2,500',
  image: require('@/assets/images/fox.jpg'),
  },
  {
  id: 4,
  title: 'Experience designed by',
  subtitle: 'JISO',
  content: 'เมืองที่ยังคงความสวยงามด้วยสถาปัตยกรรมโบราณดั้งเดิม',
  tag: 'Zoo, Travel, Flower',
  day: 'Location',
  price: 'THB 2,500',
  image: require('@/assets/images/fox.jpg'),
  },
  {
  id: 5,
  title: 'Experience designed by',
  subtitle: 'JISO',
  content: 'เมืองที่ยังคงความสวยงามด้วยสถาปัตยกรรมโบราณดั้งเดิม',
  tag: 'Zoo, Travel, Flower',
  day: 'Location',
  price: 'THB 2,500',
  image: require('@/assets/images/fox.jpg'),
  },
  {
  id: 6,
  title: 'Experience designed by',
  subtitle: 'JISO',
  content: 'เมืองที่ยังคงความสวยงามด้วยสถาปัตยกรรมโบราณดั้งเดิม',
  tag: 'Zoo, Travel, Flower',
  day: 'Location',
  price: 'THB 2,500',
  image: require('@/assets/images/fox.jpg'),
  }],
  };
  },
  beforeMount() {
    this.slides.forEach((slide, index) => this.$set(this.isActive, index, false))
  },
  methods: {
	  myFavorite(index) {
		this.$set(this.isActive, index, !this.isActive[index])
	  }
  }
};
</script>

<style lang="scss">
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css');
@import '../assets/mixins.scss';

.VueCarousel {
	.VueCarousel-slide {
		padding: 0px 7.5px;
	}
	.VueCarousel-wrapper {
		padding-bottom: 20px !important;
	}
}
.favorite-icon {
	i {
		color: #de5252 !important;
		font-size: 1rem !important;
	}
}

	.poi-item-tags {
		padding: 0;
		font-size: 0.7rem;
		font-weight: 400;
		list-style: none;
		margin-bottom: 0;
		span {
			padding-right: 15px;
		}
	}
		.text-caption-small b {
			font-size: 1rem;
			font-weight: 600 !important;
			margin: 0;
		}
		.text-caption-small .text-white:nth-child(1) {
			font-size: 1rem;
			font-weight: 400 !important;
			margin: 0;
		}
	.influencer {
		background-color: #f7f7f7;
		padding: 135px 0;

		&-container {
			box-shadow: 0px 4px 12px rgba(48, 76, 184, 0.1675);
			border-radius: 7.5px;
		}

		&-image {
			height: 300px;
		}
		&-description {
			font-weight: 500;
			line-height: 1.275;
		}
		&-price {
			line-height: 0.75;
			small {
				font-size: 0.7rem;
				font-weight: 400;
			}	
		}
		h3 {
			font-size: 1.375rem;
			font-weight: 500;
			margin: 0;
		}
		header {
			margin: 0 auto;
			text-align: center;
			width: 1180px;

			h2 {
				color: #232121;
				font-size: 2.375rem;
			}

			h3 {
				color: #767676;
				font-size: 1rem;
			}
		}

		.tabs-nav {
			padding: 0;
			margin: 16px 0 32px;

			display: flex;
			justify-content: center;

			li {
				list-style: none;
				display: inline-block;
				cursor: pointer;

				&::after {
					content: "";
					background-color: #767676;
					border-radius: 50%;
					display: inline-block;
					height: 6px;
					width: 6px;
				}

				&:last-child {
					&::after {
						display: none;
					}
				}

				a {
					color: #767676;
					padding: 0 17px;

					&:hover {
						text-decoration: none;
					}
				}
			}

			.active {
				color: #2e5596;
			}
		}

		&-container {
			display: flex;
			justify-content: space-between;
			margin: 0 auto;
		}

		&-list {
			flex: 1;
		}

		&-featured {
			position: relative;
			z-index: 5;
			&.card {
				margin-bottom: 0 !important;
				&:empty::after {
					animation: influencerFeatured 1.5s infinite;

					@keyframes influencerFeatured {
						to {
							background-position:
								350% 0,
								15px 350px,
								15px 412px,
								15px 435px,
								right 15px top 15px,
								0 468px,
								0 0;
						}
					}
				}
			}
			.influencer-image {
				position: relative;
				.bell-icon {
					right: 0;
					top: 0;
					padding: 10px;
					position: absolute;
					i {
						font-size: 1.25rem !important;
						color: #fff !important;
						opacity: .75;
					}
				}
				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		&-tabs {
			display: flex;
			flex-wrap: wrap;
			margin: 0;
			padding: 0;
		}

		&-image {
			>img {
				border-top-right-radius: 7.5px;
				border-top-left-radius: 7.5px;
				object-fit: cover;
			}
		}

		&-profile {
			margin-top: -64px;
			position: relative;
			height: 64px;
			display: flex;
			background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
			border-radius: 0 0 6px 6px;

			&-image {
				margin-left: 8px;
				height: 42px;
				width: 42px;

				>img {
					height: 42px;
					width: 42px;
				}
			}

			&-detail {
				margin-left: 10px;
				line-height: 1.35;
			}
		}

		&-main-profile {
			margin-top: -102px;
			position: relative;
			margin-bottom: 24px;

			display: flex;
			align-items: center;

			&-image {
				margin-left: 16px;
				height: 84px;
				width: 84px;

				>img {
					height: 84px !important;
					width: 84px;
				}
			}

			&-detail {
				margin-left: 20px;
				font-size: 1rem;
			}
		}

		&-topic {
			list-style: none;
			margin: 0 12px;
			height: 310px;
			width: 200px;
			cursor: pointer;

			&.card {
				&:empty::after {
					@include Skeletonscreen( // height card
						200px,
						// title position
						125px,
						// desc 1 position
						153px,
						// desc 2 position
						165px,
						// footer
						180px,
						// title height
						16px,
						// decs height
						8px,
						// width
						100px,
						// desc 1 width
						130px,
						// desc 2 width
						80px);

					animation: influencerList 1.5s infinite;

					@keyframes influencerList {
						to {
							background-position:
								350% 0,
								15px 125px,
								15px 153px,
								15px 165px,
								right 15px top 15px,
								0 180px,
								0 0;
						}
					}
				}
			}
		}

		&-tags {
			display: flex;
			font-size: 0.8rem;
			margin: 0;
			line-height: 2;
			.text-grey {
				font-weight: 400 !important;
			}
			i {
				font-size: 0.7rem !important;
			}
		}

		&-tag {
			&:not(:last-child)::after {
				content: "\2022";
				margin: 0 8px;
			}
		}
		.form-group {
			.btn-primary {
				border-radius: 25px;
				background-color: #ffc556;
				font-size: 0.85rem;
				padding: 0.5rem 1.25rem;
				border: none;
				margin-left: 12px;
				margin-top: 0.5rem;
			}
		}

		@media (max-width: 1199px) {
			.influencer-container {
				.influencer-featured {
					margin-bottom: 2.5rem;
					width: 100%;
					margin-right: 0;
				}
				.influencer-tabs {
					justify-content: flex-start;
				}
				.influencer-topic {
					height: 300px;
				}
			}
		}

		@media (max-width: 494px) {
			.influencer-topic {
				width: 100%;
				margin: 0;
			}
			.form-group {
				.btn-primary {
					margin-left: 0;
				}
			}
		}
	}
</style>